
document.addEventListener('DOMContentLoaded', function() {

   if(window.innerWidth <= 768) {
  document.querySelectorAll('ul.menu-drawer__menu.list-menu a').forEach(function(elem){
    if(elem.textContent.trim() === 'Bundles & Save'){
      elem.classList.add('bundle-save');
      // Get the parent li element and add a class to it
      var parentLi = elem.closest('li');
      if (parentLi) {
        parentLi.classList.add('custom-li-bundle');
      }
    } 
  });
}

  else{
     document.querySelectorAll('.header__menu-item--top span.label').forEach(function(elem){
    if(elem.textContent.trim() === 'Bundle & Save') {
      elem.classList.add('bundle-save');
    }
  });
  }





// document.addEventListener('DOMContentLoaded', function() {
//   debugger;
//   document.querySelectorAll('.header__menu-item--top span.label').forEach(function(elem) {
//     if (elem.textContent.trim() === 'Bundle & Save') {
//       elem.classList.add('bundle-save');
//     }
//   });













 // Function to check if the user is on a mobile device
  function isMobile() {
    return window.matchMedia("only screen and (max-width: 760px)").matches;
  }

  // If the user is on mobile
  if (isMobile()) {
    
 

    // Find the announcement bar
    var announcementBar = document.querySelector('announcement-bar');
    if (announcementBar) {
      // Find the slides and buttons within the announcement bar
      var slides = announcementBar.querySelectorAll('.announcement-slider__slide');
      var buttons = announcementBar.querySelectorAll('.announcement__button');

      // Loop through slides and hide all except the 'BUY 3 & GET 1 FREE' slide
      slides.forEach(function(slide) {
        var text = slide.querySelector('.announcement-text').textContent.trim();
        if (!text.includes('BUY 3 & GET 1 FREE')) {
          slide.style.display = 'none'; // Hide the slide
        }
      });
    


      // Remove the arrow buttons
      buttons.forEach(function(button) {
        button.style.display = 'none';
      });

      // Adjust the transform style of the 'BUY 3 & GET 1 FREE' slide
      var targetSlide = Array.from(slides).find(slide => 
        slide.querySelector('.announcement-text').textContent.trim().includes('BUY 3 & GET 1 FREE')
      );

      if (targetSlide) {
        targetSlide.style.transform = 'translateX(0%)';
      }
    }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const checkoutButton = document.querySelector('.checkout-button');
  const spinner = document.getElementById('checkout-spinner');

  checkoutButton.addEventListener('click', function() {
    spinner.style.visibility = 'visible';
  });
});
